<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<div class="inputs">
					<datepicker @rangeSelected="setRange"/>
					<select name="category" v-model="selectedCategory" @change="selectedSymptom = '0', getTrend()" :disabled="selectDisable">
						<option value="0" disabled selected>{{textCategory}}</option>
						<option :value="category" v-for="category in symptomCategories" :key="category.id">{{category.name}}</option>
					</select>
					<select name="symptom" v-model="selectedSymptom" @change="getTrend()" :disabled="selectDisable">
						<option value="0" disabled selected>{{textSymptom}}</option>
						<option :value="symptom.id" v-for="symptom in symptomsByCat(selectedCategory.name)" :key="symptom.id">{{symptom.symptom}}</option>
					</select>
				</div>
				<div class="chart">
					<div class="loading" v-if="!dateRange.date_from">{{textRange}}</div>
					<div class="loading" v-if="chartData.length == 0 && dateRange.date_from">{{textNodata}}</div>
					<line-chart :chartData="chartData" :chartLabels="chartLabels" :axislabel="axisLabel" v-if="chartData.length > 0"></line-chart>
				</div>
		        <div class="h-align-center mt-5 mb-5">
					<button class="btn icon" @click="downloadTrend()" :disabled="selectDisable">
						<svg width="24" height="24">
                            <g clip-path="url(#clip_0)">
                                <path fill="rgb(255,255,255)" stroke="none" transform="translate(0 20.5944)" d="M1.58448 0L22.1789 0C23.0542 0 23.7633 0.875311 23.7633 1.58448C23.7633 2.45979 23.0542 3.16895 22.1789 3.16895L1.58448 3.16895C0.709164 3.16895 0 2.29364 0 1.58448C0 0.709164 0.709164 0 1.58448 0Z"/>
                            </g>
                            <g clip-path="url(#clip_1)">
                                <path fill="rgb(255,255,255)" stroke="none" transform="translate(4.62012 0.131836)" d="M2.88072 9.81864C2.22077 9.16054 1.15332 9.16146 0.494269 9.81864C-0.164756 10.4758 -0.164756 11.5405 0.494269 12.1977L6.46457 18.1531C6.90455 18.5921 7.61742 18.5912 8.05738 18.1531L14.0277 12.1977C14.6867 11.5406 14.6858 10.475 14.0277 9.81864C13.3687 9.16054 12.3003 9.16146 11.6412 9.81864L8.93279 12.5207L8.93279 1.68192C8.93279 0.753719 8.17722 0 7.24528 0C6.31334 0 5.5587 0.752792 5.5587 1.68192L5.5587 12.49L2.88072 9.81864Z"/>
                            </g>
				        </svg>
						<span>{{textDownload}}</span>
					</button>
				</div>
		        <div class="h-align-center mt-5 mb-5">
					<button class="btn icon" :disabled="selectDisable" @click="showEmailModal()">
						<svg width="25" height="17">
							<g clip-path="url(#clip_0)">
								<path fill="rgb(255,255,255)" stroke="none" d="M1.13636 0C0.521562 0 0 0.521563 0 1.13636L0 15.3409C0 15.9557 0.521562 16.4773 1.13636 16.4773L23.8636 16.4773C24.4784 16.4773 25 15.9557 25 15.3409L25 1.13636C25 0.521563 24.4784 0 23.8636 0L1.13636 0ZM23.1266 1.70455L12.4999 9.99659L1.87324 1.70455L23.1266 1.70455ZM7.46621 8.22983L1.70456 3.72869L1.70456 13.6276L7.46621 8.22983ZM23.2955 3.72869L23.2955 13.6276L17.5338 8.22983L23.2955 3.72869ZM11.9762 11.7452L8.82445 9.28608L2.9743 14.7724L22.026 14.7724L16.1754 9.28608L13.0237 11.7452C12.7152 11.9849 12.2846 11.9849 11.9762 11.7452Z" fill-rule="evenodd"/>
							</g>
						</svg>
						<span>{{textEmail}}</span>
					</button>
				</div>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
		<div class="modal fade" id="emailTrend" tabindex="-1" role="dialog" aria-labelledby="emailTrendLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="emailTrendLabel"><strong>Email Trend</strong></h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="widget">
						<div class="form-group">
							<label>{{textEmailTo}}</label>
							<input type="text" v-model="modalTo" placeholder="Enter email address">
						</div>
						<div class="form-group">
							<label>{{textProfile}}</label>
							<input type="text" v-model="modalFrom" placeholder="Profile Name">
						</div>
					</div>
				</div>
				<div class="modal-footer h-align-center">
					<button class="btn icon" @click="sendTrend()">
						<svg width="25" height="17">
							<g clip-path="url(#clip_0)">
								<path fill="rgb(255,255,255)" stroke="none" d="M1.13636 0C0.521562 0 0 0.521563 0 1.13636L0 15.3409C0 15.9557 0.521562 16.4773 1.13636 16.4773L23.8636 16.4773C24.4784 16.4773 25 15.9557 25 15.3409L25 1.13636C25 0.521563 24.4784 0 23.8636 0L1.13636 0ZM23.1266 1.70455L12.4999 9.99659L1.87324 1.70455L23.1266 1.70455ZM7.46621 8.22983L1.70456 3.72869L1.70456 13.6276L7.46621 8.22983ZM23.2955 3.72869L23.2955 13.6276L17.5338 8.22983L23.2955 3.72869ZM11.9762 11.7452L8.82445 9.28608L2.9743 14.7724L22.026 14.7724L16.1754 9.28608L13.0237 11.7452C12.7152 11.9849 12.2846 11.9849 11.9762 11.7452Z" fill-rule="evenodd"/>
							</g>
						</svg>
						<span>{{textSend}}</span>
					</button>
				</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import moment from 'moment'
import jQuery from "jquery"

const FileDownload = require('js-file-download')

Vue.use(CxltToastr, moment)

//importing widgets
import textcontent from '../../components/widgets/text'
import datepicker from '../../components/track/datepicker'
import LineChart from '../../components/track/lineCharts.js'

export default {
	components: {
		textcontent,
		datepicker,
		LineChart
	},
	props:['id','date'],
	name: 'Trend',
	computed: {
		widgets() {// setting list of widgets
			return this.components
		},
		formatedDate() {
			return moment(this.date).format("MMMM Do, YYYY")
	    },
        axisLabel() {// setting label for Y-axis depends of symptom selected
            let name = ''
            if(this.selectedSymptom != 0) {
                this.symptoms.map(s=>{
                    s.id == this.selectedSymptom ? name = localStorage.lang =='en' ? 'Rate of '+s.symptom : 'Taux de '+s.symptom : ''
                })
            } else {
                name = localStorage.lang =='en' ? 'Number Of Symptoms' : "Nombre de symptômes"
            }
            return name
        }
	},
	data() {
		return {
			ps:null,
			pageData:[],
			components:[],
			comp:[],
			profile: this.$route.params.id,
			symptoms:[],
			symptomCategories:[],
			selectedCategory:'0',
			selectedSymptom:'0',
			dateRange:{},
			lang: localStorage.lang ? localStorage.lang  : 'en',
			loading:true,
			selectDisable:true,
			chartData:[],
			chartLabels:[],
			modalTo: '',
			modalFrom:'',
			textCategory: localStorage.lang =='en' ? 'Select Category' : "Choisir catégorie",
			textSymptom: localStorage.lang =='en' ? 'Select Symptom' : "Choisir symptôme",
			textRange: localStorage.lang =='en' ? 'Select a days range' : "Sélectionnez une plage de jours",
			textNodata: localStorage.lang =='en' ? 'No data' : "Aucune donnée pour cette plage et ces options",
			textDownload: localStorage.lang =='en' ? 'Download Trend' : "Télécharger tendance",
			textEmail: localStorage.lang =='en' ? 'Email Trend' : "Tendance Email",
			textEmailTo: localStorage.lang =='en' ? 'Email To:' : "Envoyer à:",
			textProfile: localStorage.lang =='en' ? 'Profile Name:' : "Nom de profil:",
			textSend: localStorage.lang =='en' ? 'Send Trend' : "Envoyer tendance",
		}
	},
	mounted: function() {
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.axios.get(process.env.VUE_APP_URL+'subsection/trend', {params:{name:'trend', language:this.lang}})
			.then(response => {
				this.pageData = response.data
		        this.prepareComponents()
		        this.getCategories()
				this.getSymptomsList()
			})
			.catch(error => {
			  	this.$router.push({path:'page/prevent'})
			})
		},
		getSymptomsList: function() { // getting all symptoms
				this.axios.get(process.env.VUE_APP_URL+'symptoms', {params:{language: localStorage.lang}})
				.then(response => {
					this.symptoms = response.data
				})
		},
		getCategories: function() { // getting all symptom categories
			this.axios.get(process.env.VUE_APP_URL+'categories', {params:{language: localStorage.lang}})
			.then(response => {
				this.symptomCategories = response.data;
			})
		},
		symptomsByCat: function(cat) { // filtering symptoms by category name
				let list = []
				this.symptoms.map(s => {
					s.category == cat ? list.push(s) : ''
				})
				return list
		},
		setRange: function(value) { // receiving date range from datepicker, fires on datepicket selectedRange change
			this.dateRange.date_from = value.start
			this.dateRange.date_to = value.end
			if(this.dateRange) {
				this.dateRange.date_from = moment(this.dateRange.date_from).format("YYYY-MM-DD")
				this.dateRange.date_to = moment(this.dateRange.date_to).format("YYYY-MM-DD")
				this.selectDisable = false
		    }
		    this.getTrend()
		},
		getTrend: function() { // getting trend data
            this.chartData = []
            this.chartLabels = []
            this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
            if(this.selectedSymptom == '0') { // if there is no symptom selected
                this.axios.get(process.env.VUE_APP_URL+'profile/'+this.profile+'/symptoms/trend',
                {params:{
                    id:this.profile,
                    date_from:this.dateRange.date_from,
                    date_to:this.dateRange.date_to,
					category:this.selectedCategory.id,
					language: localStorage.lang
                }})
                .then(response => {
                    response.data.map(res => {
                        this.chartData.push(res.symptoms)
                        this.chartLabels.push(res.date)
                    })
                })
            } else { // symptom selected => getting severity data
                this.axios.get(process.env.VUE_APP_URL+'profile/'+this.profile+'/symptom/'+this.selectedSymptom+'/severity/trend',
                {params:{
                    id:this.profile,
                    date_from:this.dateRange.date_from,
                    date_to:this.dateRange.date_to,
                    symptom_id:this.selectedSymptom,
					language: localStorage.lang
                }})
                .then(response => {
                    response.data.map(res => {
                        this.chartData.push(res.severity)
                        this.chartLabels.push(res.date)
                    })
                })
            }
        },
        downloadTrend: function() { // downloading trend data and converting it to csv
            this.axios.get(process.env.VUE_APP_URL+'/profile/'+this.profile+'/symptoms/download',
            {params:{
                id:this.profile,
                date_from:this.dateRange.date_from,
				date_to:this.dateRange.date_to,
				language: localStorage.lang
            }})
            .then(response=> {
                FileDownload(response.data, 'trend_'+this.dateRange.date_from+' - '+this.dateRange.date_to+'.csv')
            })
		},
		showEmailModal: function() { // getting profile name by id to prefill modalFrom and showing modal
			this.axios.get(process.env.VUE_APP_URL+'profile/'+this.profile, {params:{language: localStorage.lang}})
			.then(response=> {
				this.modalFrom = response.data.name
				jQuery('#emailTrend').modal('show')
			})
		},
		sendTrend: function() { // validating modal form and sending data to the server
			if(this.modalTo.length === 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter an email to send the records to',
					position: 'top right',
					timeOut: 5000
				})
			} else if (this.modalFrom.length === 0) {
				this.$toast.error({
					title:'Error',
					message: 'Please enter a name to associate with the data',
					position: 'top right',
					timeOut: 5000
				})
			} else {
				this.axios.post(process.env.VUE_APP_URL+'/profile/'+this.profile+'/symptoms/mail',
				{
					to: this.modalTo,
					from: this.modalFrom,
					date_from: this.dateRange.date_from,
					date_to: this.dateRange.date_to
				})
				.then(response=> {
					this.$toast.success({
						title:'Success',
						message: 'The email was sent successfully',
						position: 'top right',
						timeOut: 5000
					})
					jQuery('#emailTrend').modal('hide')
				})
			}
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
				this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
				this.perfectScrollInit()
			})
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>